import React from "react";
import { StyleSheet, View } from "react-native";

import StatItem from "./StatsItem";

import { type EventOverview } from "@/schemas/events/EventOverview";
import { formatDate, formatTime } from "@/formatting/datetime";
import { formatSecondaryAddress } from "@/formatting/location";
import WebCard from "@/Components/Cards/WebCard";

type Props = {
  event: EventOverview;
};

function EventStats({ event }: Props): React.JSX.Element {
  const styles = StyleSheet.create({
    container: {
      flexDirection: "row",
    },
  });

  return (
    <WebCard>
      <View style={styles.container}>
        <StatItem
          icon="event"
          label="Date"
          value={formatDate(event.startDateTime, event.timeZone)}
        />
        <StatItem
          icon="access-time"
          label="Time"
          value={`${formatTime(event.startDateTime, event.timeZone)} - ${formatTime(event.endDateTime, event.timeZone)}`}
        />
        <StatItem
          icon="location-on"
          label="Location"
          value={formatSecondaryAddress(event.location.address)}
          numberOfLines={2}
        />
        <StatItem
          icon="groups"
          label="Expected"
          value={`${event.expectedAttendance?.toLocaleString()} attendees`}
          isLast
        />
      </View>
    </WebCard>
  );
}

export default EventStats;
